import { createSelector } from 'reselect';

const range = state => state.range;

export const selectPriceRange = createSelector(
	[range],
	search => search.priceRange,
);
